/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Compare_Leveling_Member_CardsInputs */



/**
* | output |
* | --- |
* | "Members design their own rank cards" |
*
* @param {Pricing_Compare_Leveling_Member_CardsInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const pricing_compare_leveling_member_cards = /** @type {((inputs?: Pricing_Compare_Leveling_Member_CardsInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Compare_Leveling_Member_CardsInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Участники оформляют свои карточки ранга")
	return /** @type {LocalizedString} */ ("Members design their own rank cards")
});